import { render, staticRenderFns } from "./viewBox.vue?vue&type=template&id=488dc854&scoped=true&"
import script from "./viewBox.vue?vue&type=script&lang=ts&"
export * from "./viewBox.vue?vue&type=script&lang=ts&"
import style0 from "./viewBox.vue?vue&type=style&index=0&id=488dc854&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488dc854",
  null
  
)

export default component.exports